import React from "react";
import {useState,useEffect,useRef } from 'react';
import axios from "axios";
import configData from "../config.json";
import {Link} from 'react-router-dom';
import * as Icon from 'react-bootstrap-icons';
import { format } from "date-fns";

const LateAttendance=()=>{
    if(localStorage.getItem('branchID')===null){
        window.location.replace('/hris');
    }
    const [misData,setMisData]=useState([]);
    const [noResults, setNoResults] = useState(false);
    const [attenDataSum,setAttenDataSum]=useState([]);

    const [startDate, setStartDate] = useState(() => {
            const today = new Date();
            return today.toISOString().split('T')[0];
            });
    const [endDate, setEndtDate] = useState(() => {
            const today = new Date();
            return today.toISOString().split('T')[0];
            });

    useEffect(() => {

    }, []);

    
    
    const handleSubmit=async(e)=>{
        e.preventDefault();

        if (!startDate || !endDate) {
            alert('Dates required.');
            return;
        }  
        
        if (startDate > endDate) {
            alert('Invalid Date Range.');
            return;
        }

        try {
        const res = await axios.get(configData.SERVER_URL+`/lateReport/${startDate}/${endDate}/${localStorage.getItem('branchID')}`);
        setAttenDataSum(res.data || []);
      
        if (res.data.length === 0) {
            setNoResults(true);
        } else {
            setNoResults(false);
        }
        } catch (error) {
            console.error('Search error:', error);
        }   
    }

    const printDiv = (printDiv) => {

    const printElement = document.getElementById(printDiv);

        if (!printElement) {
            console.error("Print div not found");
            return;
        }

        const printWindow = window.open("", "_blank", "width=900,height=650");

        printWindow.document.write(`
            <html>
                <head>
                <title>Print</title>
                <!-- Bootstrap CSS (optional) -->
                <link rel="stylesheet"  href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"/>
                <style>
                    body{ padding:20px; font-family: Arial, sans-serif;}
                    @media print { body{ margin:0; }}
                </style>
                </head>
                <body>
                    ${printElement.innerHTML}
                </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 500);
    };


    return(
    <>
    <div className='container'>
        <div className="card shadow border-0" id="printDiv_Late"
    style={{ background: "#fff", borderRadius: "18px", overflow: "hidden", }}>
  {/* Header */}
  <div
    className="card-header d-flex justify-content-between align-items-center"
    style={{
      background: "linear-gradient(135deg, #0d6efd, #0dcaf0)",
      color: "#fff",
      padding: "18px 25px",
      border: "none",
    }}
  >
    <div>
      <h3 className="mb-0 fw-bold">Late Summary Report</h3>
      <small>Employee late attendance statistics</small>
    </div>

    <button  type="button" className="btn btn-light"
      onClick={()=>printDiv("printDiv_Late")}
      style={{ borderRadius: "50px", padding: "10px 18px", fontWeight: "600",}}
    >
      <Icon.Printer className="me-2" />
      Print
    </button>
  </div>

  {/* Filter Section */}
  <div className="card-body">
    <div
      className="row g-3 align-items-end mb-4 p-3"
      style={{
        backgroundColor: "#f8f9fa",
        borderRadius: "12px",
      }}
    >
      <div className="col-lg-4 col-md-6">
        <label className="form-label fw-semibold text-secondary">
          Start Date
        </label>

        <input
          type="date"
          className="form-control shadow-sm"
          name="startDate"
          id="startDate"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          style={{
            borderRadius: "10px",
            height: "45px",
          }}
        />
      </div>

      <div className="col-lg-4 col-md-6">
        <label className="form-label fw-semibold text-secondary">
          End Date
        </label>

        <input
          type="date"
          className="form-control shadow-sm"
          name="endDate"
          id="endDate"
          value={endDate}
          onChange={(e) => setEndtDate(e.target.value)}
          style={{
            borderRadius: "10px",
            height: "45px",
          }}
        />
      </div>

      <div className="col-lg-2 col-md-4">
        <button
          type="button"
          className="btn btn-primary w-100 shadow-sm"
          onClick={(e) => handleSubmit(e)}
          style={{
            borderRadius: "10px",
            height: "45px",
            fontWeight: "600",
          }}
        >
          <Icon.Search className="me-2" />
          Search
        </button>
      </div>
    </div>

    {/* No Data */}
    {noResults && (
      <div className="alert alert-warning text-center fw-semibold">
        No results found.
      </div>
    )}

    {/* Table */}
    <div className="table-responsive">
      <table className="table table-hover align-middle table-bordered">
        <thead
          style={{
            background: "#0d6efd",
            color: "#fff",
          }}
        >
          <tr className="text-center">
            <th>SL</th>
            <th>Department</th>
            <th>Emp Code</th>
            <th>Employee Name</th>
            <th>09:00 - 09:15</th>
            <th>09:15 - 09:30</th>
            <th>09:30 Above</th>
            <th>Total Late</th>
          </tr>
        </thead>

        <tbody>
          {attenDataSum &&
            attenDataSum.length > 0 &&
            attenDataSum.map((data, index) => (
              <tr key={index}>
                <td>{index + 1}</td>

                <td>{data.deptName}</td>

                <td>{data.empCode}</td>

                <td className="fw-semibold">{data.empName}</td>

                <td className="text-success fw-bold">
                  {data.slot1}
                </td>

                <td
                  className="fw-bold"
                  style={{
                    color: data.slot2 > 0 ? "#0d6efd" : "#212529",
                  }}
                >
                  {data.slot2}
                </td>

                <td
                  className="fw-bold"
                  style={{
                    color: data.slot3 > 0 ? "#dc3545" : "#212529",
                  }}
                >
                  {data.slot3}
                </td>

                <td>
                  <span
                    className="badge"
                    style={{
                      backgroundColor: "#198754",
                      fontSize: "14px",
                      padding: "8px 12px",
                      borderRadius: "8px",
                    }}
                  >
                    {Number(data.slot1) +
                      Number(data.slot2) +
                      Number(data.slot3)}
                  </span>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  </div>
        </div>
    </div>
    </>
    )
}

export default LateAttendance;